/**
 * OVERRIDE DefaultView.jsx
 */

import DefaultView from '../../../../components/View/DefaultView';

export default DefaultView;